import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import { Box, Grid, Typography, useTheme } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import WsFlexbox from './WsFlexbox';
import WsGridContainer from './WsGridContainer';
import WsGridItem from './WsGridItem';

interface Props {
  sx?: any;
  title: string;
  width: string;
  icon?: JSX.Element;
  variant?: 'h3' | 'h4' | 'h5' | 'h6';
}

const WsInfoFrame = (props: PropsWithChildren<Props>) => {
  const theme = useTheme();

  return (
    <>
      <Grid container sx={{ width: props.width }}>
        <Grid
          item
          xs={12}
          sx={{
            [`& svg`]: {
              fontSize: 36,
            },
          }}
        >
          <WsFlexbox>
            {props.icon ? props.icon : null}
            <Typography pt={1} pl={0.5} color="primary" variant={props.variant || 'h5'}>
              {props.title}
            </Typography>
          </WsFlexbox>
        </Grid>
        <Grid
          container
          item
          xs={12}
          sx={{
            // border: '2px solid blue',
            width: '100%',
            borderBottomWidth: 2,
            borderBottomStyle: 'solid',
            borderBottomColor: theme.palette.secondary.main,
            borderTopWidth: 2,
            borderTopStyle: 'solid',
            borderTopColor: theme.palette.secondary.main,
            paddingLeft: 2,
            paddingRight: 2,
          }}
        >
          {props.children}

          {/* <Grid
            item
            xs={12}
            sx={{
              width: '100%',
              borderBottomWidth: 1,
              borderBottomStyle: 'solid',
              borderBottomColor: theme.palette.secondary.main,
              borderTopWidth: 1,
              borderTopStyle: 'solid',
              borderTopColor: theme.palette.secondary.main,
              paddingLeft: 2,
              paddingRight: 2,
              // paddingBottom: 2,
            }}
          >
          </Grid> */}
          {/* <Grid item xs={6} sx={{ border: '2px solid blue' }}>
            Inner2
          </Grid> */}
        </Grid>
      </Grid>
      {/* <Grid container sx={{ border: '1px solid red', width: '60%' }}>
        <Grid item xs={6} sx={{ border: '2px solid blue' }}>
          Grid Item
        </Grid>
        <Grid item xs={6} sx={{ border: '2px solid blue' }}>
          Grid Item 2
        </Grid>
      </Grid> */}
    </>

    // <Grid
    //   container
    //   item
    //   sx={{
    //     width: props.width,
    //   }}
    // >
    //   <WsGridItem
    //     xs={12}
    //     sx={{
    //       [`& svg`]: {
    //         fontSize: 36,
    //       },
    //     }}
    //   >
    //     {props.icon ? props.icon : null}
    //     <Typography p={1} color="primary" variant="h4">
    //       {props.title}
    //     </Typography>
    //   </WsGridItem>
    //   <WsGridItem
    //     xs={12}
    //     sx={{
    //       width: '100%',
    //       borderBottomWidth: 1,
    //       borderBottomStyle: 'solid',
    //       borderBottomColor: theme.palette.secondary.main,
    //       borderTopWidth: 1,
    //       borderTopStyle: 'solid',
    //       borderTopColor: theme.palette.secondary.main,
    //       paddingLeft: 2,
    //       paddingRight: 2,
    //       // paddingBottom: 2,
    //     }}
    //   >
    //     {props.children}
    //   </WsGridItem>
    // </Grid>
  );
};

export default WsInfoFrame;
